import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const RegimeEspecialCard = ({ regimeEspecial }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Regime Especial</b>
      </div>
      <div className="card-body">
        {" "}
        <center>
          <table className="table table-striped table-bordered" width="80%">
            <thead>
              <tr>
                <th>
                  <center>Descrição do regime</center>
                </th>
                <th>
                  <center>Data inicial</center>
                </th>
                <th>
                  <center>Observação</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {regimeEspecial?.map((regime) => (
                <tr>
                  <td>{regime.descricaoRegime}</td>
                  <td>
                    <center>{formatarData(regime.dataInicioRegime, "dd/MM/yyyy")}</center>
                  </td>
                  <td>{regime.observacaoRegime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default RegimeEspecialCard;
